import {
  BILLING_TAB,
  COLUMN_PACKAGE,
  COLUMN_PACKAGE_BILLING,
} from '../../../constants';
import { IOSSwitch } from '../../mainScreen.styled';
import PriceConfirmationModal from '../PriceConfirmationModal';
import ServicesTable from '../ServicesTable';
import PackageDetail from './PackageDetail';
import { CloseIcon, EyeIcon, RemoveIcon } from '@/assets/svg';
import { mergeArrayByKey } from '@/helpers';
// import { renderPackageAction } from '../../renderAction';
import validateData from '@/helpers/validationHelpers/validationSchema';
import { TableWrapped } from '@/module/checkin-patient-information/styled';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import packageDispatcher from '@/module/package-management/action/package';
import { isBillableProject } from '@/module/setup/utils';
import CustomAsyncAutocompleteModal from '@/new-components/CustomAsyncAutocompleteModal';
import CustomMenuActions from '@/new-components/CustomMenuActions';
import customToast from '@/new-components/CustomNotification';
import CustomTooltip from '@/new-components/CustomTooltip';
import {
  TableCell,
  Dialog,
  Menu,
  TextField,
  InputAdornment,
  Button,
  withStyles,
  IconButton,
} from '@material-ui/core';
import { Visibility, MoreVertRounded } from '@material-ui/icons';
import { cloneDeep, findIndex, isEmpty } from 'lodash';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import styled from 'styled-components';

const StyledWrapModalContent = styled.div`
  padding: 16px;
  h1 {
    text-align: center;
    margin-top: 16px;
  }

  p {
    text-align: center;
    margin-bottom: 32px;
  }
  min-width: 500px;
`;

const StyledModalFooter = styled.div`
  display: flex;
  justify-content: center;
`;

export const TABLE_STATE = {
  Outside: 'Outside',
  Modal: 'Modal',
};

const CustomActionButton = withStyles({
  root: {
    paddingTop: 4,
    paddingBottom: 4,
    fontSize: 16,
    textTransform: 'unset',
  },
})(Button);

const CustomTextFieldPrice = withStyles((theme) => ({
  root: {
    fontSize: 20,

    '& .MuiInputBase-input': {
      marginLeft: 0,
    },

    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 6,
    },

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: 36,
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 16,
    },
    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
        height: theme.spacing(4.25),
      },
    },
  },
}))(TextField);

const Packages = ({ formValue, setFormValue, errors, setErrors }) => {
  const newSelected = useRef([]);

  const [showModal, setShowModal] = useState(false);
  const [showPriceConfirmationModal, setShowPriceConfirmationModal] =
    useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [itemSelected, setItemSelected] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentValue, setCurrentValue] = useState(0);
  const [currentState, setCurrentState] = useState(TABLE_STATE.Outside);
  const [modal, setModal] = useState({});

  const [isViewModal, setIsViewModal] = useState(false);
  const [totalErrors, setTotalErrors] = useState(0);
  const [listPackages, setListPackages] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  const [billingTab, setBillingTab] = useState(BILLING_TAB.Default);

  const [openModalConfirmDefaultPrice, setOpenModalConfirmDefaultPrice] =
    useState(false);
  const [modalConfirmDefaultPriceData, setModalConfirmDefaultPriceData] =
    useState();
  const [numberPackageEdited, setNumberPackageEdited] = useState(0);
  const [isPriceChanged, setIsPriceChanged] = useState(false);
  const [modalSelectedItems, setModalSelectedItems] = useState([]);
  const onAddNewPackage = (newSelected) => {
    const selected = selectedList.concat(newSelected);
    const selectedObjects = listPackages.concat(modalSelectedItems);

    let newList = [];
    newList = mergeArrayByKey(selected, selectedObjects, 'id');
    newList = mergeArrayByKey(newList, formValue.lstPackages, 'id');
    setFormValue({ ...formValue, lstPackages: newList });
    setShowModal(false);
    setIsViewModal(false);
    setCurrentState(TABLE_STATE.Outside);
    setSelectedList(selected);
  };

  const handleClosePriceConfirmationModal = () => {
    setShowPriceConfirmationModal(false);
    newSelected.current = [];
  };

  const handleConfirmPriceConfirmationModal = () => {
    onAddNewPackage(newSelected.current);

    setShowPriceConfirmationModal(false);
    newSelected.current = [];
  };

  /** Deprecated function ? */
  const handleClickAddPackages = (data) => {
    if (totalErrors !== 0) {
      customToast('error', 'Please enter the price again.');
      return;
    }
    const itemsEdited = data.filter((item) => item.isEdit === true);

    if (numberPackageEdited === data.length && numberPackageEdited === 0) {
      onAddNewPackage(data);
      setNumberPackageEdited(0);
      return;
    }
    setNumberPackageEdited(itemsEdited.length);
    setOpenModalConfirmDefaultPrice(true);
    setModalConfirmDefaultPriceData(data);
  };

  const handleClickConfirmDefaultPrice = () => {
    onAddNewPackage(modalConfirmDefaultPriceData);
    setOpenModalConfirmDefaultPrice(false);
  };

  const handleClickCancelDefaultPrice = () => {
    setOpenModalConfirmDefaultPrice(false);
  };

  const onDeletePackage = () => {
    let newListPackages = cloneDeep(formValue.lstPackages).filter(
      (it) => it.id !== selectedItem.id
    );
    let newSelectedItem = cloneDeep(selectedList).map((item) =>
      item.id === selectedItem.id ? { ...item, isChecked: false } : item
    );
    const index = findIndex(newListPackages, (it) => it.id === selectedItem.id);
    newSelectedItem.splice(index, 1);

    setIsViewModal(false);
    setSelectedList(newSelectedItem);
    setFormValue({ ...formValue, lstPackages: newListPackages });
  };

  const onChangePrice =
    (tableOnly, position, tableValue, setTableValue) => (value) => {
      const formatValue = Number(value);
      if (tableOnly) {
        let lstPackages = [...selectedList];
        lstPackages[position].price = formatValue;
        setFormValue({ ...formValue, lstPackages });
      } else {
        let newVal = [...tableValue];
        newVal[position].price = formatValue;
        setTableValue(newVal);
      }
    };

  /** Deprecated function ? */
  const calculateData = (position, callback) => {
    const isOutside = currentState === TABLE_STATE.Outside;
    return {
      position,
      values: isOutside ? formValue : modal.value,
      setValues: isOutside ? setFormValue : modal.setValue,
      key: isOutside && 'lstPackages',
      callback,
    };
  };

  /** Deprecated function ? */
  const submitChangeData = async (
    tableOnly,
    row,
    tableValue,
    setTableValue
  ) => {
    let newVal = [];
    try {
      await validateData(
        'priceSchema',
        {
          price: currentValue,
        },
        (data) => {
          if (tableValue) {
            newVal = [...tableValue].map((item) =>
              item.id === row.id
                ? {
                    ...item,
                    isEdit: item.id === row.id,
                  }
                : item
            );
            const index = tableValue.indexOf(row);
            const itemsEdited = newVal.filter((item) => item.isEdit === true);
            const totalErrors = newVal.filter((item) => item.errs).length;

            onChangePrice(
              tableOnly,
              index,
              newVal,
              setTableValue,
              row
            )(data.price);
            setTableValue(newVal);
            setNumberPackageEdited(itemsEdited.length);
            setTotalErrors(totalErrors);
          } else setIsViewModal(true);
          setCurrentValue(0);
        }
      );
    } catch (errs) {
      newVal = [...tableValue].map((item) =>
        item.id === row.id
          ? {
              ...item,
              errs: errs.price,
            }
          : item
      );
      const totalErrors = newVal.filter((item) => item.errs).length;
      setTableValue(newVal);
      setTotalErrors(totalErrors);
    }
  };

  const handleChangePrice = (rowId, rowIndex, value) => {
    const isOutside = currentState === TABLE_STATE.Outside;
    // Regex test number contain decimal. Maximum length number of decimal is 2
    const regexNumber = /^([\d]{0,9})(\.[\d]{1,2})?$/g;
    if (isOutside) {
      let newListPackages = cloneDeep(formValue.lstPackages);

      if (regexNumber.test(value)) {
        const price = parseFloat(value);
        newListPackages[rowIndex].price = Number.isNaN(price) ? value : price;
      }

      setFormValue({
        ...formValue,
        lstPackages: newListPackages,
      });
    } else {
      let newListPackages = cloneDeep(listPackages);
      const index = findIndex(newListPackages, (it) => it.id === rowId);

      if (regexNumber.test(value)) {
        const price = parseFloat(value);
        newListPackages[index].price = Number.isNaN(price) ? value : price;
        newListPackages[index].billableAmount = isBillableProject(
          formValue.billingType
        )
          ? newListPackages[index].price
          : 0;
      }

      setListPackages(newListPackages);
    }
  };

  const handleClearPrice = (rowId, rowIndex) => {
    const isOutside = currentState === TABLE_STATE.Outside;

    if (isOutside) {
      let newListTests = cloneDeep(formValue.lstPackages);
      newListTests[rowIndex].price = '';
      setFormValue({
        ...formValue,
        lstPackages: newListTests,
      });
    } else {
      let newListTests = cloneDeep(listPackages);
      const index = findIndex(newListTests, (it) => it.id === rowId);
      newListTests[index].price = '';
      newListTests[index].billableAmount = '';
      setListPackages(newListTests);
    }
  };

  const handleChangeBillableAmount = (rowId, rowIndex, value) => {
    // Regex test number contain decimal. Maximum length number of decimal is 2
    const regexNumber = /^([\d]{0,9})(\.[\d]{1,2})?$/g;
    const newListPackages = cloneDeep(formValue.lstPackages);

    if (regexNumber.test(value)) {
      const billableAmount = parseFloat(value);
      newListPackages[rowIndex].billableAmount = Number.isNaN(billableAmount)
        ? value
        : billableAmount;
    }

    setFormValue({
      ...formValue,
      lstPackages: newListPackages,
    });
  };

  useEffect(() => {
    if (!isEmpty(formValue?.lstPackages)) {
      const newSelected = [...formValue?.lstPackages].map((i) => i.id);
      setSelectedList(newSelected);
    }
  }, [formValue]);

  useEffect(() => {
    if (!showModal && currentState !== TABLE_STATE.Outside) {
      setCurrentState(TABLE_STATE.Outside);
    }
  }, [currentState, showModal]);

  const renderRow = (row, rowIndex) => {
    return (
      <>
        <TableCell style={{ fontSize: 16 }}>
          <CustomTooltip content={row.name} />
        </TableCell>
        <TableCell style={{ fontSize: 16, width: 100 }}>
          {row.packageType}
        </TableCell>
        <TableCell style={{ fontSize: 16 }}>
          <CustomTextFieldPrice
            type="number"
            variant="outlined"
            value={row.price}
            onChange={(e) =>
              handleChangePrice(row.id, rowIndex, e.target.value)
            }
            error={!!errors?.lstPackages?.[row.id]?.price}
            helperText={errors?.lstPackages?.[row.id]?.price?.trim()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{
                      visibility:
                        row.price && !isEmpty(String(row.price))
                          ? 'visible'
                          : 'hidden',
                    }}
                    onClick={() => handleClearPrice(row.id, rowIndex)}
                  >
                    <CloseIcon
                      height={20}
                      width={20}
                      style={{
                        color: '#666666',
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </TableCell>
        {!showModal && (
          <>
            <TableCell style={{ fontSize: 16, width: 100 }}>
              <IOSSwitch
                checked={row?.isVisible}
                color="primary"
                name="isVisible"
                size="medium"
                onChange={(e) => {
                  setFormValue({
                    ...formValue,
                    lstPackages: formValue.lstPackages.map((item) =>
                      item.id === row.id
                        ? { ...item, isVisible: e.target.checked }
                        : item
                    ),
                  });
                }}
              />
            </TableCell>
            <TableCell style={{ fontSize: 16, width: 100 }}>
              {row?.packageType === 'EHS' && (
                <IOSSwitch
                  checked={!!row?.isHomebasedEligible}
                  color="primary"
                  name="isHomebasedEligible"
                  size="medium"
                  onChange={(e) => {
                    setFormValue({
                      ...formValue,
                      lstPackages: formValue.lstPackages.map((item) =>
                        item.id === row.id
                          ? { ...item, isHomebasedEligible: e.target.checked }
                          : item
                      ),
                    });
                  }}
                />
              )}
            </TableCell>
          </>
        )}
        <TableCell>
          {showModal ? (
            <CustomActionButton
              color="primary"
              startIcon={<Visibility />}
              onClick={() => {
                onViewDetail(row.id);
                setIsViewModal(true);
              }}
            >
              View
            </CustomActionButton>
          ) : (
            <IconButton
              style={{ width: 20, height: 20 }}
              onClick={(e) => {
                setSelectedItem(row);
                setAnchorEl(e.currentTarget);
              }}
            >
              <MoreVertRounded />
            </IconButton>
          )}
        </TableCell>
      </>
    );
  };

  const renderBillingRow = (row, rowIndex) => {
    return (
      <>
        <TableCell style={{ fontSize: 16 }}>
          <CustomTooltip content={row.name} />
        </TableCell>
        <TableCell style={{ fontSize: 16, width: 100 }}>
          {row.packageType}
        </TableCell>
        <TableCell style={{ fontSize: 16 }}>
          <CustomTextFieldPrice
            type="number"
            variant="outlined"
            value={row.billableAmount}
            onChange={(e) =>
              handleChangeBillableAmount(row.id, rowIndex, e.target.value)
            }
            error={!!errors?.lstPackages?.[row.id]?.billableAmount}
            helperText={errors?.lstPackages?.[row.id]?.billableAmount?.trim()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{
                      visibility:
                        row.billableAmount &&
                        !isEmpty(String(row.billableAmount))
                          ? 'visible'
                          : 'hidden',
                    }}
                    onClick={() =>
                      handleChangeBillableAmount(row.id, rowIndex, '')
                    }
                  >
                    <CloseIcon
                      height={20}
                      width={20}
                      style={{
                        color: '#666666',
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </TableCell>

        {!showModal && (
          <TableCell style={{ fontSize: 16, width: 100 }}>
            <IOSSwitch
              checked={row?.isVisible}
              color="primary"
              name="isVisible"
              size="medium"
              disabled
              onChange={(e) => {
                setFormValue({
                  ...formValue,
                  lstPackages: formValue.lstPackages.map((item) =>
                    item.id === row.id
                      ? { ...item, isVisible: e.target.checked }
                      : item
                  ),
                });
              }}
            />
          </TableCell>
        )}
      </>
    );
  };

  const onViewDetail = (id) => {
    setAnchorEl(null);
    setShowDetailModal(true);
    packageDispatcher.getPackageById(id, (result) => setItemSelected(result));
  };

  const listActions = [
    {
      key: 'view',
      icon: EyeIcon,
      label: 'View details',
      onClick: () => {
        onViewDetail(selectedItem.id);
        setShowModal(true);
        setIsViewModal(true);
        setCurrentValue({});
        setAnchorEl(null);
      },
    },
    {
      key: 'delete',
      icon: RemoveIcon,
      label: 'Remove',
      color: '#DB3D49',
      onClick: () => {
        onDeletePackage();
        setCurrentValue({});
        setAnchorEl(null);
      },
    },
  ];

  const checkIsPriceChanged = (newSelected) => {
    const newList = mergeArrayByKey(newSelected, listPackages, 'id');

    return newList.some(
      (newItem) =>
        newItem.price !==
        originalList.find((originalItem) => originalItem.id === newItem.id)
          ?.price
    );
  };

  /**
   * Function to double check 2 cases:
   *  1. Submit data: data !== undefined
   *  2. Cancel edit: data === undefined
   */
  const doubleCheckBeforeCloseDialog = (data) => {
    if (data) {
      newSelected.current = data;
      setIsPriceChanged(checkIsPriceChanged(newSelected.current));
      setShowPriceConfirmationModal(true);
    } else {
      // _tempListPackages.current && setListPackages(_tempListPackages.current);
      setShowModal(false);
      setIsViewModal(false);
    }
  };

  const renderColumn = useCallback(
    (column) => {
      // If showModal is true, then hide the column isVisible
      // COLUMN_PACKAGE, COLUMN_PACKAGE_BILLING
      if (showModal) {
        return column.filter(
          (item) =>
            !['isVisible', 'isHomebasedEligible'].includes(item.stateValue)
        );
      }
      return column;
    },
    [showModal]
  );
  return (
    <TableWrapped>
      <ServicesTable
        title="Available packages"
        labelButton="Add package"
        columns={renderColumn(COLUMN_PACKAGE)}
        renderRow={renderRow}
        data={formValue.lstPackages}
        onClick={(e) => {
          e && e.preventDefault();
          setCurrentState(TABLE_STATE.Modal);
          setShowModal(!showModal);
        }}
        billingColumns={renderColumn(COLUMN_PACKAGE_BILLING)}
        renderBillingRow={renderBillingRow}
        billingTab={billingTab}
        setBillingTab={setBillingTab}
        showBillingTab={isBillableProject(formValue.billingType)}
        hasBillingErrors={!!Object.keys(errors?.lstPackages || {}).length}
      />
      <CustomAsyncAutocompleteModal
        open={showModal}
        onClose={doubleCheckBeforeCloseDialog}
        onSubmit={doubleCheckBeforeCloseDialog}
        submitLabel="Add"
        title="package"
        columns={renderColumn(COLUMN_PACKAGE)}
        searchPlaceholder="Search by name..."
        onViewDetail={onViewDetail}
        selectedItem={selectedList}
        setSelectedItem={setSelectedList}
        modalSelectedItems={modalSelectedItems}
        setModalSelectedItems={setModalSelectedItems}
        renderRow={renderRow}
        isViewModal={isViewModal}
        setIsViewModal={setIsViewModal}
        ViewModal={() => {
          return <PackageDetail data={itemSelected} />;
        }}
        endpoint="packages/filter"
        method="post"
        onDataLoaded={(data) => {
          setListPackages(
            data.map((i) => ({
              ...i,
              isVisible: i.isVisible || true,
              price: i.price || 0,
              billableAmount: isBillableProject(formValue.billingType)
                ? i.price || 0
                : 0,
            }))
          );
          setOriginalList(
            data.map((i) => ({
              ...i,
              isVisible: i.isVisible || true,
              price: i.price || 0,
              billableAmount: isBillableProject(formValue.billingType)
                ? i.price || 0
                : 0,
            }))
          );
        }}
        data={listPackages}
        setData={setListPackages}
      />
      <Menu
        style={{ zIndex: 1301 }}
        id="menu-location"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {anchorEl && <CustomMenuActions listActions={listActions} />}
      </Menu>

      <Dialog
        maxWidth="lg"
        open={openModalConfirmDefaultPrice}
        onClose={handleClickCancelDefaultPrice}
        disableEnforceFocus
      >
        <StyledWrapModalContent>
          {numberPackageEdited > 0 ? (
            <h1>There are some prices have been changed!</h1>
          ) : (
            <h1>Default package prices were used!</h1>
          )}

          <p>Click "OK" to add, or click "Cancel" to edit</p>
          <StyledModalFooter>
            <ButtonEnhance
              background="#E9E9E9"
              color="black"
              backgroundHover="#ccc"
              onClick={handleClickCancelDefaultPrice}
            >
              Cancel
            </ButtonEnhance>

            <ButtonEnhance onClick={handleClickConfirmDefaultPrice}>
              OK
            </ButtonEnhance>
          </StyledModalFooter>
        </StyledWrapModalContent>
      </Dialog>

      <PriceConfirmationModal
        open={showPriceConfirmationModal}
        onClose={handleClosePriceConfirmationModal}
        onConfirm={handleConfirmPriceConfirmationModal}
        isPriceChanged={isPriceChanged}
      />
    </TableWrapped>
  );
};

export default Packages;
